(function() {
    'use strict';
    

a3_cabin_reports.run(runBlock);

/* @ngInject */ 
function runBlock($rootScope, $timeout, $location,$anchorScroll, UserFactory, UserTokenFactory,$templateCache,SettingsMain, SWUpdateService,
    CabinReportLocalEditFactory,CrewAssessmentFactory,PaxInfoFactory,LogService, SaCrewAssessmentFactory, ASSFReportFactory) {
    //make sure that each route change validates that the user is still logged in
    var valid = ['/login', '/reset', '/debug','/ticket'];
    $rootScope.$on('$routeChangeStart', function(event, next, current) {
        if (valid.indexOf($location.$$path) < 0 && !UserFactory.isLoggedIn()) {
            event.preventDefault();
            $location.path('/login');
        }
 
        //START - SERVICE WORKERS
        if ('serviceWorker' in navigator) {
            SWUpdateService.initialize();

            navigator.serviceWorker.getRegistration().then(function(registration) {
                $rootScope.SWRegistration = registration;

            });
            SWUpdateService.checkUpdates($rootScope.SWRegistration);
        }
        //END - SERVICE WORKERS
        
         $anchorScroll.yOffset = 100;
        
        if(valid.indexOf($location.$$path) < 0 && (!current || !current.$$route || !next.$$route || current.$$route.controller != next.$$route.controller)){
        //Check if temp report of any kind exists
            var editingPage = SettingsMain.getEditingPage();
            SettingsMain.setEditingPage(null);

            if (editingPage == 'report') {
                // check if a temp report exists in local storage
                if (CabinReportLocalEditFactory.getCabinReportLocalEditFromTemp() != null) {
                    $location.path("report/temp");
                }
            } 
            else if (editingPage == 'assessment') {
                // check if a temp assessment exists in local storage
                if (CrewAssessmentFactory.getTempAssessment() != null) {
                    $location.path("assessment/temp");
                }
            }
            else if (editingPage == 'saAssessment') {
                // check if a temp assessment exists in local storage
                if (SaCrewAssessmentFactory.getTempAssessment() != null) {
                    $location.path("saAssessment/temp");
                }
            }
            else if (editingPage == 'assfReport') {
                // check if a temp assfReport exists in local storage
                if (ASSFReportFactory.getTempAssfReport() != null) {
                    $location.path("assfReport/temp");
                }
            }

            //Method: Clear specific cache on route change
            if (typeof(current) !== 'undefined') {
                 $templateCache.remove(current.templateUrl);
            }

    
        }
    
    });
 
   
    $rootScope.idbSupported = ("indexedDB" in window);
    
    $rootScope.isOffline = !window.navigator.onLine;
    
    window.addEventListener('offline', function (e) { $timeout($rootScope.isOffline = !window.navigator.onLine); });
    window.addEventListener('online', function (e) { $timeout($rootScope.isOffline = !window.navigator.onLine); });
    
    
    $("body").on("click",".memo-body a", function(){
        var link = $(this).attr("href");
        if (link && link.indexOf("surveymonkey")>0){
            LogService.debug(link);
        }
        
    })
    
    //maintain the user token, outside the localStorage, needed for submitting js errors
    var user = UserFactory.getUser();
    if (user && user.token) 
        UserTokenFactory.setToken(user.token);
    else 
        UserTokenFactory.setToken('');
}
    
})();